//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'

export default {
  name: 'Holiday2021CrisisBanner',

  computed: {
    ...mapGetters('user', ['isSubscriber']),

    show() {
      const paths = [
        /index/,
        /get_started/,
        /free_trial.*/,
        /landing.*/,
        /refer-a-friend/,
        /products.*/,
        /checkout.*/,
        /cancel/
      ]
      return !paths.some(p => p.test(this.$route.name))
    }
  }
}
